export { default } from './Webcam.tsx'
export type { WebcamOptions } from './Webcam.tsx'
